import {Flex} from '/app/src/component';
import style from './style.css'
import React from 'react';

const OffOptionStyle = (isSelected) => ({
    className: style.LargeContainerStyle,
    vAlignContent: 'center',
    border: isSelected ? '3px solid #2ea2d2': '3px solid transparent',
    hoverBorder: isSelected ? '3px solid #2ea2d2' : '3px solid #f0f0f0',
})

const RadioLabelStyle = (isSelected) => ({
        fontSize: '24px',
        lineHeight: '24px',
        fontWeight: isSelected?'500':'300',
        color: 'black',
        basis: '15%'
})

export default ({current, index, onSelected}) => {
    const isSelected = current === index

    return(
        <Flex onClick={onSelected(index)} {...OffOptionStyle(isSelected)}>
            <Flex {...RadioLabelStyle(isSelected)}> Av </Flex>
            <Flex grow fontSize='18px' > Offlineformuläret visas inte för besökare. </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/OfflineSettings/_OffOption.js